
// export const CORE_API_ENDPOINT = `https://frontweb.rmbainisys.com/depa`

// export const CORE_API_ENDPOINT = `http://10.0.30.9:8801/api`
// 
// export const CORE_API_ENDPOINT = `/depa`

// export const CORE_API_ENDPOINT = `/api/core`

// export const CORE_API_ENDPOINT = `http://localhost:2000`

//.9 new 2020
export const CORE_API_ENDPOINT = `/api`
export const SLOT_DURATION = 1


// WEBPACK FOOTER //
// ./src/front/lib/api.js